import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import MainLayouts from "../../layout/MainLayouts";
import client from "../../api/client";

const Categories1 = () => {
  const [categoriesData, setCategoriesData] = useState([]);
  
  useEffect(() => {
    client.get('/v2/categories')
      .then(res => {
        // The API returns the array directly
        const data = Array.isArray(res.data) ? res.data : (res.data.data || []);
        
        const mappedCategories = data.map(category => {
          // Determine icon based on name/slug
          const name = category.name.toLowerCase();
          let iconStr = 'database';
          if (name.includes('data')) iconStr = 'database';
          if (name.includes('ai') || name.includes('machine')) iconStr = 'cpu';
          if (name.includes('engineering') || name.includes('dev')) iconStr = 'code';
          if (name.includes('analy')) iconStr = 'chart-bar';
          if (name.includes('design') || name.includes('product')) iconStr = 'code';
          if (name.includes('market') || name.includes('business')) iconStr = 'chart-bar';

          return {
            id: category.id,
            slug: category.slug,
            title: category.name, // Use 'name' from the backend model
            desc: category.description || "Explore this category to find the perfect course for your career goals.",
            courseCount: category.courses_count || Math.floor(Math.random() * 5) + 1,
            image: category.image_url || "https://images.unsplash.com/photo-1550439062-609e1531270e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
            icon: iconStr
          };
        });
        setCategoriesData(mappedCategories);
      })
      .catch(err => console.error("Error fetching categories", err));
  }, []);

  return (
    <MainLayouts>
      <div className="pt-32 pb-24 bg-[#0b0f19] min-h-screen">
        <div className="max-w-[1560px] mx-auto px-6">
          
          {/* Header */}
          <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end mb-20 gap-8">
            <div className="w-full lg:w-1/2">
              <div className="text-[11px] font-bold tracking-[0.15em] uppercase text-primary mb-6 flex items-center gap-3">
                <span className="block w-8 h-[2px] bg-primary"></span>
                LEARNING PATHS
              </div>
              <h1 className="text-white text-4xl md:text-6xl font-bold leading-tight">
                Explore Our Fields<br />of Study<span className="text-primary">.</span>
              </h1>
            </div>
            <div className="w-full lg:w-1/2 flex lg:justify-end items-end gap-6">
              <p className="text-gray-400 text-lg max-w-[450px] leading-relaxed border-l border-primary/30 pl-6">
                Discover your next career move. Our immersive programs are designed to transform beginners into highly sought-after tech professionals.
              </p>
            </div>
          </div>

          {/* Categories Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {categoriesData.map((category, index) => (
              <Link
                to={`/courses/category/${category.slug || category.id}`}
                key={category.id || index}
                className="group relative h-[400px] lg:h-[500px] rounded-[32px] overflow-hidden flex flex-col justify-end p-8 lg:p-12 transition-transform duration-700 hover:-translate-y-2 hover:shadow-2xl hover:shadow-primary/20 block"
              >
                {/* Background Image */}
                <img 
                  src={category.image} 
                  alt={category.title} 
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1500ms] group-hover:scale-110"
                />
                
                {/* Gradient Overlays */}
                <div className="absolute inset-0 bg-gradient-to-t from-[#0b0f19] via-[#0b0f19]/70 to-transparent transition-opacity duration-500 group-hover:opacity-90"></div>
                
                {/* Content */}
                <div className="relative z-10">
                  <div className="flex items-center gap-4 mb-6">
                    <div className="w-16 h-16 rounded-2xl bg-white/10 backdrop-blur-md border border-white/20 flex items-center justify-center text-white group-hover:bg-primary group-hover:border-primary transition-all duration-300">
                      {/* Simple SVG icon based on category mapping */}
                      {category.icon === 'chart-bar' && (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-8 h-8"><path strokeLinecap="round" strokeLinejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z" /></svg>
                      )}
                      {category.icon === 'database' && (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-8 h-8"><path strokeLinecap="round" strokeLinejoin="round" d="M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125" /></svg>
                      )}
                      {category.icon === 'cpu' && (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-8 h-8"><path strokeLinecap="round" strokeLinejoin="round" d="M8.25 3v1.5M4.5 8.25H3m18 0h-1.5M4.5 12H3m18 0h-1.5m-15 3.75H3m18 0h-1.5M8.25 19.5V21M16.5 3v1.5m0 15V21m-8.25-9h8.25m-8.25 0a2.25 2.25 0 01-2.25-2.25V8.25a2.25 2.25 0 012.25-2.25h8.25a2.25 2.25 0 012.25 2.25v2.25a2.25 2.25 0 01-2.25 2.25m-8.25 0v3a2.25 2.25 0 002.25 2.25h3.75a2.25 2.25 0 002.25-2.25v-3" /></svg>
                      )}
                      {category.icon === 'code' && (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-8 h-8"><path strokeLinecap="round" strokeLinejoin="round" d="M17.25 6.75L22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3l-4.5 16.5" /></svg>
                      )}
                    </div>
                    <span className="px-4 py-1.5 rounded-full bg-white/10 backdrop-blur-md border border-white/20 text-white text-[11px] font-bold uppercase tracking-wider">
                      {category.courseCount} Courses
                    </span>
                  </div>
                  
                  <h2 className="text-white text-3xl md:text-5xl font-bold mb-4 group-hover:text-primary transition-colors duration-300">
                    {category.title}
                  </h2>
                  
                  <div className="grid grid-rows-[0fr] group-hover:grid-rows-[1fr] transition-all duration-500 ease-in-out">
                    <div className="overflow-hidden">
                      <p className="text-gray-300 text-lg mb-8 leading-relaxed max-w-xl">
                        {category.desc}
                      </p>
                      <div className="inline-flex items-center gap-4 text-white font-bold uppercase tracking-wider text-[13px] border-b-2 border-primary pb-1 group-hover:text-primary transition-colors">
                        Explore Category
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className="w-4 h-4 transform group-hover:translate-x-1 transition-transform"><path strokeLinecap="round" strokeLinejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3"></path></svg>
                      </div>
                    </div>
                  </div>
                  
                </div>
              </Link>
            ))}
          </div>

        </div>
      </div>
    </MainLayouts>
  );
};

export default Categories1;
